import { useEffect, useState } from 'react';
import { useStore } from 'effector-react';
import { Button, Card, Form, InputNumber, Modal, Space, Table, notification } from 'antd';
import { PageTemplate } from '@/shared/ui/templates';
import { DiContainer } from '@@/di/di-container';
import { DlpService } from '../../services/dlp.service';
import {
  $labSegments,
  $mixSteps,
  fetchLabSegmentsFx,
  fetchMixStepsFx,
} from '../../store/dlp.store';
import { MixStep } from '../../ts';

const PARAMS = [
  { id: 1, name: 'Клейковина' },
  { id: 2, name: 'Влажность' },
  { id: 3, name: 'ИДК' },
  { id: 4, name: 'ЧП' },
  { id: 5, name: 'Протеин' },
  { id: 6, name: 'Натура' },
];

export const DlpLabPage = () => {
  const svc = () => DiContainer.get(DlpService);
  const segments = useStore($labSegments);
  const steps = useStore($mixSteps);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState<{ type: 'segment' | 'step'; id: number } | null>(null);
  const [form] = Form.useForm();

  const reload = () => {
    fetchLabSegmentsFx();
    fetchMixStepsFx();
  };
  useEffect(() => {
    reload();
  }, []);

  const openModal = (type: 'segment' | 'step', id: number) => {
    form.resetFields();
    setModal({ type, id });
  };

  const save = async () => {
    const values = await form.validateFields();
    const payload: Record<string, number> = {};
    PARAMS.forEach((p) => {
      if (values[p.id] !== undefined && values[p.id] !== null) payload[p.id] = Number(values[p.id]);
    });
    setLoading(true);
    try {
      if (modal?.type === 'segment') await svc().updateSegmentQuality(modal.id, payload);
      else if (modal?.type === 'step') await svc().updateMixStep(modal!.id, payload);
      notification.success({ message: 'Сохранено' });
      setModal(null);
      reload();
    } catch (e: any) {
      notification.error({ message: e?.error || e?.message || 'Ошибка' });
    } finally {
      setLoading(false);
    }
  };

  const segColumns = [
    { title: 'ID', dataIndex: 'id', key: 'id' },
    { title: 'Рукав', dataIndex: 'bag_id', key: 'bag_id' },
    { title: 'Вес', dataIndex: 'weight', key: 'weight' },
    {
      title: 'Действие',
      key: 'a',
      render: (_: any, s: any) => (
        <Button size="small" onClick={() => openModal('segment', s.id)}>
          Правка текущего качества
        </Button>
      ),
    },
  ];

  const stepColumns = [
    { title: 'Партия', key: 'code', render: (_: any, s: MixStep) => s.derived_lot?.code || s.derived_lot_id },
    { title: 'Шаг', dataIndex: 'step_order', key: 'step_order' },
    { title: 'Вес', dataIndex: 'weight', key: 'weight' },
    {
      title: 'Факт внесён',
      key: 'fact',
      render: (_: any, s: MixStep) => (s.fact_quality ? 'да' : 'нет'),
    },
    {
      title: 'Действие',
      key: 'a',
      render: (_: any, s: MixStep) => (
        <Button size="small" type="primary" onClick={() => openModal('step', s.id)}>
          Внести факт
        </Button>
      ),
    },
  ];

  return (
    <PageTemplate header="Лаборатория">
      <div style={{ padding: 16 }}>
        <Card title="Шаги смешивания (факт после каждого шага)" style={{ marginBottom: 16 }}>
          <Table rowKey="id" loading={loading} columns={stepColumns} dataSource={steps} pagination={false} />
        </Card>
        <Card title="Сегменты — текущее качество (дозревание)">
          <Table rowKey="id" columns={segColumns} dataSource={segments} pagination={{ pageSize: 20 }} />
        </Card>
      </div>

      <Modal
        open={!!modal}
        title={modal?.type === 'step' ? 'Факт лаборатории по шагу' : 'Текущее качество сегмента'}
        onOk={save}
        confirmLoading={loading}
        onCancel={() => setModal(null)}
      >
        <Form form={form} layout="vertical">
          <Space wrap>
            {PARAMS.map((p) => (
              <Form.Item key={p.id} name={p.id} label={p.name}>
                <InputNumber style={{ width: 120 }} />
              </Form.Item>
            ))}
          </Space>
        </Form>
      </Modal>
    </PageTemplate>
  );
};
